import { FiatCurrency } from '@/constants/currency';
import { FarmPool } from '../balancer/subgraph/types';
import { TokenPrices } from '../coingecko/api/price.service';
import LiquidityConcern from './concerns/liquidity.concern';

export default class PoolService {
  pool: FarmPool;
  liquidityConcern: LiquidityConcern;

  constructor(pool: FarmPool, liquidityConcernClass = LiquidityConcern) {
    this.pool = pool;
    this.liquidityConcern = new liquidityConcernClass(this);
  }

  public calcTotalLiquidity(
    prices: TokenPrices,
    currency: FiatCurrency
  ): string {
    try {
      return this.liquidityConcern.calcFarmPoolTotal(prices, currency);
    } catch (error) {
      console.error('Failed to calc pool liquidity:', error);
      return '0';
    }
  }
}
